<SmartButton v-model="show_navbar"
:set="true" :unset="false"><slot/></SmartButton>